module.exports = __webpack_public_path__ + "static/media/Fighting Spirit-2-01.c6c9c289.svg";